import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '2020加油干——重庆两会特别报道';

const route: RouteConfig = {
  path: '/2020CQLHReport',
  name: '2020',
  component: () => import('./ViewHolder.vue'),
  redirect: '/2020CQLHReport/Home',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'Home',
      name: 'CQLH_Home',
      component: () => import('./Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
